import React from 'react'
import styled from 'styled-components'

import { desktopVw } from '../../styles/utils'
import { isLoggedIn } from '../../utils'

import { Input, Container } from '../FormElements'
import Button from '../Button'

import ReferralPoints from './ReferralPoints'
import { ReferralFormHeader, StyledButton } from './ReferralStyle'
import { useTranslation } from 'next-i18next'

const Form = styled.form`
  margin-bottom: 42px;
  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(44)};
  }
`

const ActivateAccount = styled(Button)`
  padding: 22px;
  margin-bottom: 30px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(30)};
    padding: ${desktopVw(11)} ${desktopVw(50)};
  }
`

const ReferralPointsContainer = styled.div`
  border-top: 1px solid ${props => props.theme.colors.greyLighter};
  margin-bottom: 96px;
  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(350)};
  }
`

const ReferralPointsWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.greyLighter};
`

const StyledInput = styled(Input)`
  height: 50px;
  width: 314px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    width: ${desktopVw(350)};
  }
`

const Success = ({
  handleSubmit,
  handleChange,
  referralCode,
  targetEmail,
  successfulReferrals,
  invitedReferrals,
  submitButtonText,
  loading,
}) => {
  const { t } = useTranslation('common')
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <ReferralFormHeader>
          <h1>
            <i>{t('thanks_for_referring')}</i>
          </h1>
          <p>{t('remind_your_friends_to_check_their_email')}</p>
        </ReferralFormHeader>
        <Container>
          <StyledInput
            // @i18n-ignore
            type="text"
            name="targetEmail"
            required
            value={targetEmail}
            placeholder={t('your_friend_s_email_separated_by_commas')}
            onChange={handleChange}
          />
        </Container>
        <Container>
          <StyledButton
            // @i18n-ignore
            type="submit"
            black
            loading={loading}
          >
            {submitButtonText}
          </StyledButton>
        </Container>
      </Form>
      <ReferralPointsContainer>
        <ReferralPointsWrapper>
          <ReferralPoints
            title={t('successfully_referred_friends')}
            referrals={successfulReferrals || []}
            totalText={t('total_earned_points')}
            noReferralsMsg={t('no_successful_referrals_yet')}
          />
        </ReferralPointsWrapper>
        {!isLoggedIn() && (
          <ActivateAccount
            black
            to="/sign-up"
            trackParams={{
              trackInternal: true,
              trackGA: true,
              // @i18n-ignore
              category: 'referral',
              action: 'activate_account',
            }}
          >
            {t('activate_your_account_to_access_rewards')}
          </ActivateAccount>
        )}
        <ReferralPointsWrapper>
          <ReferralPoints
            title={t('your_referrals')}
            referrals={invitedReferrals || []}
            totalText={t('total_potential_points')}
            noReferralsMsg={t('no_referrals_yet')}
          />
        </ReferralPointsWrapper>
      </ReferralPointsContainer>
    </>
  )
}

export default Success
